'use client';

export {
    generate as generateProductDescription,
    createProductDescription,
    productDescriptionTemplateTypeKey,
    showCutList as productDescriptionShowCutList,
    OFFICIAL_PRODUCT_DESCRIPTION_TYPE_KEY,
} from './define';

export * from './ProductDescription';
